import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

import SupportServiceIcon from '@icons/SupportServiceIcon';
import { routesMap } from '@shared/lib';

import styles from './View.module.css';

export const View = ({ children }: { children: ReactNode }) => (
  <main className={styles.page}>
    <header className={styles.topbar}>
      <Link to={routesMap.auth} aria-label="Go to sign in">
        <img className={styles.logo} src="/gcard-logotype.svg" alt="GCARD" />
      </Link>
    </header>
    <div className={styles.center}>{children}</div>
    <button
      className={styles.supportButton}
      type="button"
      aria-label="Contact support"
    >
      <SupportServiceIcon className={styles.supportIcon} />
    </button>
  </main>
);
